import { render, staticRenderFns } from "./salesReturn.vue?vue&type=template&id=8fafbf2e&scoped=true"
import script from "./salesReturn.vue?vue&type=script&lang=js"
export * from "./salesReturn.vue?vue&type=script&lang=js"
import style0 from "./salesReturn.vue?vue&type=style&index=0&id=8fafbf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fafbf2e",
  null
  
)

export default component.exports